import { render, staticRenderFns } from "./PreviewReceipt.vue?vue&type=template&id=70494baa&scoped=true"
import script from "./PreviewReceipt.vue?vue&type=script&lang=js"
export * from "./PreviewReceipt.vue?vue&type=script&lang=js"
import style0 from "./PreviewReceipt.vue?vue&type=style&index=0&id=70494baa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70494baa",
  null
  
)

export default component.exports